

// import React, { useState } from "react";
// import "./style.scss";
// import { createPortal } from "react-dom"; 
// import logo from "../../../static/img/logo-1.png";

// const PrimaryMenu = ({ className = "",setOpen,open }) => {
  
//   const handleClose = () => setOpen(false);


//  const portalTarget =
//     typeof document !== "undefined" ? document.body : null;

//   return (
//         <>
//       {/* Scrim is rendered on <body>, so it always covers the whole viewport */}
//       {/* {open && portalTarget &&
//         createPortal(
//           <button
//             className="nav-scrim"
//             aria-hidden="true"
//             onClick={handleClose}
//           />,
//           portalTarget
//         )
//       } */}
//     <header className={`primary-menu ${className}`}>
//       {/* Brand + burger */} 
//       {/* {open && <button className="nav-scrim" aria-hidden="true" onClick={() => setOpen(false)} />} */}
//       <div className="brand">
//         <a href="/" className="logo" onClick={handleClose}>
//           <img src={logo} alt="CardsFolio" />
//           <span className="sr-only">CardsFolio</span>
//         </a>

//      <button
//   className={`menu-toggle${open ? " is-open" : ""}`}
//   aria-expanded={open}
//   aria-controls="primary-nav"
//   aria-label={open ? "Close navigation" : "Open navigation"}
//   onClick={() => setOpen(v => !v)}
// >
//   {/* You can keep ☰ even when open; or show ✕ when open */}
//   <span aria-hidden="true">{open ? "✕" : "☰"}</span>
// </button>
// {/* {open && <button className="nav-scrim" aria-hidden="true" onClick={() => setOpen(false)} />} */}
//       </div>

//       {/* Main nav */}
//       <nav id="primary-nav" className={`nav ${open ? "open" : ""}`}>
//         <ul className="options" onClick={handleClose}>
//           <li><a href="/">Home</a></li>
//           <li><a href="/marketplace">Market & Trades</a></li>
//           <li><a href="/search">Search</a></li>
//           <li className="hide-sm"><a href="/graph">Graph</a></li>
//           <li className="hide-sm"><a href="/community">Community</a></li>

//           <li>     <div className="mobile-actions" onClick={handleClose}>
//           <a href="/login" className="btn link">Login</a>
//           <a href="/signup" className="btn primary">Sign Up</a>
//         </div></li>
//         </ul>

  
//       </nav>

//       {/* Desktop actions (hidden on mobile) */}
//       <div className="actions">
//         <a href="/login" className="btn link">Login</a>
//         <a href="/signup" className="btn primary">Sign Up</a>
//       </div>
      
//     </header>
//     </>
//   );
// };

// export default PrimaryMenu;


// PrimaryMenu.jsx
import React, { useEffect, useMemo, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.scss";
import { createPortal } from "react-dom";
import SportSwitcher from "../../../../utils/SportSwitcher";
// ⬇️ Adjust paths as needed based on your folder structure
import { AuthContext } from "../../../../components/login/AuthContext";
import LanguageSwitcher from "../../../../utils/language/LanguageSwitcher";
import translations from "../../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import { useCart } from "../../../../components/Cart/CartContext";
import NotificationIcon from "../../../../components/Notification/NotificationIcon";
import shoppingCartIcon from "../../icons/shopping-cart.svg";
import bellIcon from "../../icons/bell.svg";
import messageicon from "../../icons/message-circle.svg";
import profilIcon from "../../icons/user-round-pen.svg";
import settingIcon from "../../icons/settings.svg";
import logoutIcon from "../../icons/logout.svg";
// Keep your nice logo
import logo from "../../../../assets/static/img/Logo-Horizontal-Dark.png";


import { fetchJSON } from "../../../../api";
const PrimaryMenu = ({ className = "" }) => {
  const location = useLocation();

  // --- Auth / cart / i18n ---
  const { userId, userName, logout, liveCsrfToken,jwtToken, loading, isAuthenticated } =
    useContext(AuthContext);
  const { cart } = useCart();

  const { t: _t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.navbar?.[key]?.[currentLang] ?? key;

  // --- Localized path helper ---
  const localizedPath = (path) => (currentLang === "fr" ? `/fr${path}` : path);

  // --- Mobile open state + scrim ---
  const [open, setOpen] = useState(false);
  const portalTarget = typeof document !== "undefined" ? document.body : null;
  const handleClose = () => setOpen(false);

  // --- Unread / notifications like old Navbar ---
  const [notifications, setNotifications] = useState([]);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  const notificationCount = notifications?.length ?? 0;
const [bellCount, setBellCount] = useState(0);
  // const preparedNotifications = (raw) => {
  //   if (!raw || typeof raw !== "object") return [];
  //   const arr = [];
  //  // if (raw.unread_trade_offers > 0) arr.push({ id: 1, title: "Trade offer", content: raw.unread_trade_offers });
  //   if (raw.unread_card_sales > 0) arr.push({ id: 2, title: "Sales To Fulfilled", content: raw.unread_card_sales });
  //   if (raw.unread_card_offers > 0) arr.push({ id: 3, title: "Offer To Buy", content: raw.unread_card_offers });
  //   if (raw.waiting_for_payment > 0) arr.push({ id: 4, title: "Waiting for Payment", content: raw.waiting_for_payment });
  //   if (raw.waiting_for_shipment > 0) arr.push({ id: 5, title: "Waiting for Shipment", content: raw.waiting_for_shipment });
  //   return arr;
  // };

  const fetchUnreadMessages = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/messages/unread/${userId}`,
        { method: "GET", credentials: "include",headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${jwtToken}`
            
          }, }
      );
      const data = await res.json();
      setUnreadMessagesCount(Number(data?.totalUnreadMessages || 0));
    } catch (e) {
      console.error("Unread messages error:", e);
    }
  };

  // const fetchNotification = async () => {
  //   try {
  //     const res = await fetch(
  //       "https://projet-collect-v1-production.up.railway.app/api/notifications/getAll",
  //       {
  //         method: "GET",
  //         credentials: "include",
  //         headers: {
  //           "Content-Type": "application/json",
  //            "Authorization": `Bearer ${jwtToken}`
  //         },
  //       }
  //     );
  //     if (!res.ok) throw new Error(`HTTP ${res.status}`);
  //     const json = await res.json();
  //     setNotifications(preparedNotifications(json));
  //     console.log('[NOTIFICATIONS]',preparedNotifications(json));
  //   } catch (e) {
  //     console.error("Notifications error:", e);
  //   }
  // };
const preparedNotifications = (raw) => {
  if (!raw || typeof raw !== "object") return [];
  const arr = [];

  // New types/fields
  if (raw.unread_trade_offers > 0)  arr.push({ id: 1, title: "Trade Offer",         content: raw.unread_trade_offers });
  if (raw.unread_card_offers > 0)   arr.push({ id: 2, title: "Offer To Buy",         content: raw.unread_card_offers });
  if (raw.unread_card_sales > 0)    arr.push({ id: 3, title: "Sales To Fulfilled",   content: raw.unread_card_sales });
  if (raw.waiting_for_payment > 0)  arr.push({ id: 4, title: "Waiting for Payment",  content: raw.waiting_for_payment });
  if (raw.waiting_for_shipment > 0) arr.push({ id: 5, title: "Waiting for Shipment", content: raw.waiting_for_shipment });

  // Optional: reflect unread_tx as “Status Updates”
  if (raw.unread_tx > 0)            arr.push({ id: 6, title: "Status Updates",       content: raw.unread_tx });

  return arr;
};

async function fetchNotificationSummary() {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/api/notifications/summary`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${jwtToken}`,
          },
        }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      console.log('sumamry,',json)
      setBellCount(Number(json?.unread_total)+json?.waiting_for_payment+json?.waiting_for_shipment); // <-- single source of truth

    } catch (e) {
      console.error("Notification summary error:", e);
    }
  }




  // Wait for AuthContext like old Navbar did
  useEffect(() => {
    (async () => {
      let tries = 0;
      while (!window.__AUTH_READY__ && tries < 10) {
        await new Promise((r) => setTimeout(r, 300));
        tries++;
      }

      if (isAuthenticated) {
        fetchNotificationSummary();
        fetchUnreadMessages();
      }
    })();
  }, [loading, isAuthenticated, userId, liveCsrfToken]);

  // --- Active route helper (optional) ---
  const isActive = (p) => location.pathname === p || location.pathname === localizedPath(p);

  // Small inline icon from the old Navbar
  const MessageIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 24 24" aria-hidden>
      <path
        stroke="#fafafa"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19.4 18a5.5 5.5 0 1 0-4.9 3H21s-1-1-1.586-2.97M18.85 12a7.5 7.5 0 1 0-14.423 1C5.5 16.012 3 18 3 18h6.5"
      />
    </svg>
  );

  // Close the panel when a nav item is clicked (mobile)
  const onNavClick = () => setOpen(false);

useEffect(() => {
  if (!open) return;

  // hard lock body scroll (works on iOS too)
  const y = window.scrollY;
  const { style, classList } = document.body;
  classList.add('nav-open');     // for CSS overflow:hidden
  style.position = 'fixed';
  style.top = `-${y}px`;
  style.width = '100%';

  return () => {
    const top = style.top;
    classList.remove('nav-open');
    style.position = '';
    style.top = '';
    style.width = '';
    // restore scroll position
    window.scrollTo(0, Math.max(0, -parseInt(top || '0', 10)));
  };
}, [open]);


  return (
    <>
      {/* Scrim over full viewport when menu is open (mobile) */}
 

      <header className={`primary-menu ${className}`} style={{maxWidth:"100vw"}}>
        {/* Brand + burger */}
        
        <div className={`brand ${open ? "fix" : ""}`}>
          <Link to={localizedPath("/")} className="logo" onClick={handleClose}>
            <img src={logo} alt="CardsFolio" />
            <span className="sr-only">CardsFolio</span>
          </Link>
          
             <div className="sport-switcher-desktop">
  <SportSwitcher />
</div>
          <button
            className={`menu-toggle${open ? " is-open" : ""}`}
            aria-expanded={open}
            aria-controls="primary-nav"
            aria-label={open ? "Close navigation" : "Open navigation"}
            onClick={() => setOpen((v) => !v)}
          >
            <span aria-hidden="true">{open ? "✕" : "☰"}</span>
          </button>
        </div>

        {/* Main nav */}
        <nav id="primary-nav" className={`nav ${open ? "open" : ""}`}>
          <div className="sport-switcher-mobile">
   <LanguageSwitcher />
  <SportSwitcher />
  
   
  
</div>
          <ul className="options" onClick={onNavClick}>

                        {isAuthenticated && userId != null &&
<li className="mobile-only">
  <div className="mobile-utils">
    <Link
      to={localizedPath("/MessageDisplayParent")}
      className="util"
      onClick={onNavClick}
    >
      <span className="notif-trigger"><img src={messageicon} alt="" /></span>
      {/* <span className="label">{t("Chat") ?? "Messages"}</span> */}
      {unreadMessagesCount > 0 && <i className="badge">{unreadMessagesCount}</i>}
    </Link>

    {/* Use a simple link for mobile (dropdown bells are awkward in drawers) */}
    {/* <Link
      to={localizedPath("/notifications")}
      className="util"
      onClick={onNavClick}
    >
      <span className="icon"><img src={bellIcon} alt="" /></span>
      <span className="label">{t("Notifications")}</span>
      {notificationCount > 0 && <i className="badge">{notificationCount}</i>}
    </Link> */}
{/* <div onClick={(e=>e.stopPropagation())}> */}

{/* <NotificationIcon asChild content={notifications} count={notificationCount}>
  <Link className="util" onClick={(e) => e.stopPropagation()}>
    <span className="icon"><img src={bellIcon} alt="" /></span>
    <span className="label">{t("Notifications") ?? "Notifications"}</span>
    {notificationCount > 0 && <i className="badge">{notificationCount}</i>}
  </Link>
</NotificationIcon> */}
<a className="util">
<NotificationIcon count={bellCount} /></a>
    <Link
      to={localizedPath("/cart")}
      className="util"
      onClick={onNavClick}
    >
      <span className="notif-trigger"><img src={shoppingCartIcon} alt="" /></span>
      {/* <span className="label">{t("Cart")}</span> */}
      {cart?.length > 0 && <i className="badge">{cart.length}</i>}
    </Link>
  </div>
</li>}

            <li className={isActive("/") ? "active" : ""}>
              <Link to={localizedPath("/")}>{t("home")}</Link>
            </li>
            <li className={isActive("/marketplace") ? "active" : ""}>
              <Link to={localizedPath("/marketplace")}>{t("marketAndtrade")}</Link>
            </li>

            {isAuthenticated && userId != null && (
              <li className={isActive("/myCollection") ? "active" : ""}>
                <Link to={localizedPath("/myCollection")}>{t("myCollection")}</Link>
              </li>
            )}

            {/* <li className={isActive("/search") ? "active" : ""}>
              <Link to={localizedPath("/search")}>{t("search")}</Link>
            </li> */}

            {/* Optional extras (these weren't in translations; see notes below) */}
            {/* <li className="hide-sm">
              <Link to={localizedPath("/graph")}>Graph</Link>
            </li>
            <li className="hide-sm">
              <Link to={localizedPath("/community")}>Community</Link>
            </li> */}

            {/* Mobile-only auth actions */}
            {/* <li>
              <div className="mobile-actions">
                {isAuthenticated && userId != null ? (
                  <>
                    <Link to={localizedPath(`/ViewUserProfil/${userName}`)} className="btn link">
                      {t("myProfile")}
                    </Link>
                    <Link to={localizedPath("/signup2")} className="btn primary">
                      {t("settings")}
                    </Link>
                  </>
                ) : (
                  <>
                    <Link to={localizedPath("/login2")} className="btn link">
                      {t("logIn")}
                    </Link>
                    <Link to={localizedPath("/signup2")} className="btn primary">
                      {t("signUp") ?? "Sign Up"}
                    </Link>
                  </>
                )}
              </div>
            </li> */}

            {/* ---------- MOBILE: utilities row (badges) ---------- */}


{/* ---------- MOBILE: profile/actions + language ---------- */}
<li className="mobile-only">
  <div className="mobile-actions stacked">
    {isAuthenticated && userId != null ? (
      <>
        <Link to={localizedPath(`/ViewUserProfil/${userName}`)} className="btn" onClick={onNavClick}>
          {t("myProfile")}
        </Link>
        <Link to={localizedPath("/ProfilChoice")} className="btn" onClick={onNavClick}>
          {t("settings")}
        </Link>
        {/* Log out */}
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a className="btn danger" onClick={logout}>{t("logOut")}</a>
      </>
    ) : (
      <>
        <Link to={localizedPath("/login")} className="btn link" onClick={onNavClick}>
          {t("logIn")}
        </Link>
        <Link to={localizedPath("/register")} className="btn primary" onClick={onNavClick}>
          {t("signUp") ?? "Sign Up"}
        </Link>
      </>
    )}
  </div>

  {/* Language switcher on mobile too */}
 
</li>

          </ul>
        </nav>

        {/* Desktop actions (hidden on mobile in CSS) */}
        <div className="actions">
          {/* Right side: Chat + Notifications + Cart (when logged in) */}
          {isAuthenticated && userId != null ? (
            <>
              {/* Messages */}
<Link
  to={localizedPath("/MessageDisplayParent")}
  className="btn with-icon"
  onClick={onNavClick}
>
 
      <span className="notif-trigger"><img src={messageicon} alt="" /></span>
      {/* <span className="label">{t("Chat") ?? "Messages"}</span> */}
      {unreadMessagesCount > 0 && <i className="badge">{unreadMessagesCount}</i>}
    </Link>



{/* Notifications bell stays as is */}
     <span className="btn with-icon">
  <NotificationIcon content={notifications} count={bellCount} />
</span>


{/* Cart */}
<Link
  to={localizedPath("/cart")}
  className="btn with-icon"
  onClick={onNavClick}
>
  <span className="notif-trigger" aria-hidden><img src={shoppingCartIcon}/></span>
  
  {cart?.length > 0 && <span className="badge">{cart.length}</span>}
</Link>


              {/* “More” dropdown (profile, settings, logout) */}
              <div className="dropdown">
                <div className="dropdown-wrapper">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="#" onClick={(e) => e.preventDefault()}>{t("more")} ▼</a>
                  <div className="sousmenu">
                    <ul>
                      <li>
                        <Link to={localizedPath(`/ViewUserProfil/${userName}`)} onClick={onNavClick}>
                          <img src={profilIcon} style={{width:"16px", height:"16px"}}/>  {t("myProfile")}
                        </Link>
                      </li>
                      <li>
                        <Link to={localizedPath("/ProfilChoice")} onClick={onNavClick}>
                          <img src={settingIcon} style={{width:"16px", height:"16px"}}/>  {t("settings")}
                        </Link>
                      </li>
                      <li>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a onClick={logout}><img src={logoutIcon} style={{width:"16px", height:"16px"}}/>  {t("logOut")}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <Link to={localizedPath("/login")} className="btn link" onClick={onNavClick}>
                {t("logIn")}
              </Link>
              <Link to={localizedPath("/register")} className="btn primary" onClick={onNavClick}>
                {t("signUp") ?? "Sign Up"}
              </Link>
            </>
          )}

          {/* Language switcher always visible */}
          <LanguageSwitcher />
        </div>
      </header>
    </>
  );
};

export default PrimaryMenu;
